/* MAEN: Contact (sections/maen-contact.liquid) – 2026-10-15, Contact page.
   1. After the theme's page loader: the "What is it about?" line + tiles fade up one after another (title + text never
      fade). The form and the link row fade up as they come into view. Only with .maen-ct--anim (not in the theme
      editor / reduced motion / "Animate" off).
   2. A tile that opens the form picks its topic chip and glides to the form, just under the sticky header.
   3. The repair chip swaps the fields for the note + button in the same space (and back on another chip).
   4. Scroll button → the form part, under the sticky header.
   5. After sending (Shopify returns with ?contact_posted=true#anchor): the thank-you gets the focus. */
(() => {
  if (window.maenContact) return;

  const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const glide = (el) => {
    const header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
    const top = el.getBoundingClientRect().top + window.scrollY - header - 24;
    window.scrollTo({ top: Math.max(0, top), behavior: reduce() ? 'auto' : 'smooth' });
  };

  // after the theme's page loader (body.is-loaded); runs once, at the latest after 6 s
  const whenLoaded = (fn) => {
    let done = false;
    const go = () => { if (done) return; done = true; fn(); };
    if (document.body.classList.contains('is-loaded')) return go();
    const mo = new MutationObserver(() => {
      if (!document.body.classList.contains('is-loaded')) return;
      mo.disconnect();
      go();
    });
    mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    setTimeout(() => { mo.disconnect(); go(); }, 6000);
  };

  const init = (root) => {
    if (root.dataset.maenCtJs) return;
    root.dataset.maenCtJs = '1';
    const anim = root.classList.contains('maen-ct--anim');
    const form = root.querySelector('.maen-ct__form');
    const swap = root.querySelector('.maen-ct__swap');
    const note = root.querySelector('[data-maen-ct-notebox]');
    const radios = Array.from(root.querySelectorAll('input[name="contact[Topic]"]'));

    // 1. fade-ups
    if (anim) {
      whenLoaded(() => root.classList.add('is-in'));
      const parts = Array.from(root.querySelectorAll('.maen-ct__r'));
      const io = new IntersectionObserver((es) => {
        es.forEach((e) => {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-shown');
          io.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -8% 0px' });
      parts.forEach((p) => io.observe(p));
    }

    // 3. repair chip ⇄ fields
    const sync = () => {
      if (!swap || !note) return;
      const on = radios.some((r) => r.checked && r.hasAttribute('data-maen-ct-note'));
      swap.classList.toggle('is-note', on);
      note.setAttribute('aria-hidden', on ? 'false' : 'true');
      note.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', on ? '0' : '-1'));
      swap.querySelectorAll('.maen-ct__fields input, .maen-ct__fields textarea, .maen-ct__fields button').forEach((el) => {
        if (on) el.setAttribute('tabindex', '-1'); else el.removeAttribute('tabindex');
      });
    };
    radios.forEach((r) => r.addEventListener('change', sync));
    sync();

    // 2. tiles that open the form with their topic
    root.querySelectorAll('[data-maen-ct-topic]').forEach((tile) => {
      tile.addEventListener('click', (e) => {
        if (!form) return;
        e.preventDefault();
        const want = (tile.getAttribute('data-maen-ct-topic') || '').trim().toLowerCase();
        const hit = radios.find((r) => r.value.trim().toLowerCase() === want && !r.disabled);
        if (hit) { hit.checked = true; sync(); }
        glide(form);
      });
    });

    // 4. scroll button
    const cue = root.querySelector('[data-maen-ct-next]');
    const main = root.querySelector('[data-maen-ct-main]');
    if (cue && main) cue.addEventListener('click', () => glide(main));

    // 5. thank-you after sending
    const thanks = root.querySelector('[data-maen-ct-thanks]');
    // after the theme's own in-page focus on the #anchor target
    if (thanks) setTimeout(() => thanks.focus({ preventScroll: true }), 700);
  };

  const run = () => document.querySelectorAll('[data-maen-ct]').forEach(init);
  window.maenContact = { run };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
